import { Exclude, Expose } from "class-transformer";
import { IsBoolean, IsDefined, IsObject, IsOptional, IsString } from "class-validator";

@Exclude()
export class StripeInformation {
    @IsString()
    @IsDefined()
    @Expose()
    public id: string;

    @IsString()
    @Expose()
    @IsOptional()
    public businessType?: string | null;

    @IsBoolean()
    @IsDefined()
    @Expose()
    public chargesEnabled: boolean;

    @IsString()
    @IsDefined()
    @Expose()
    public type: string;

    @IsBoolean()
    @IsDefined()
    @Expose()
    public payoutsEnabled: boolean;

    @IsString()
    @Expose()
    @IsOptional()
    public defaultCurrency?: string;

    @IsString()
    @Expose()
    @IsOptional()
    public country?: string;

    @IsObject()
    @Expose()
    @IsOptional()
    public metadata?: object;

    @IsObject()
    @IsOptional()
    @Expose()
    public capabilities?: object;
}
